export const ANALYTICS_EVENTS = {
  // Authentication
  USER_LOGIN: "user_login",
  USER_LOGOUT: "user_logout",
  USER_REGISTRATION: "user_registration",

  // App Usage
  APP_OPENED: "app_opened",
  APP_BACKGROUNDED: "app_backgrounded",
  APP_FOREGROUND: "app_foreground",
  SCREEN_VIEW: "screen_view",
  FEATURE_USED: "feature_used",

  // Workout Events
  WORKOUT_STARTED: "workout_started",
  WORKOUT_COMPLETED: "workout_completed",
  WORKOUT_ABANDONED: "workout_abandoned",
  EXERCISE_STARTED: "exercise_started",
  EXERCISE_COMPLETED: "exercise_completed",
  REST_TIMER_STARTED: "rest_timer_started",
  REST_TIMER_COMPLETED: "rest_timer_completed",

  // Progress & Reports
  WEEKLY_REPORT_STARTED: "weekly_report_started",
  WEEKLY_REPORT_COMPLETED: "weekly_report_completed",
  PROGRESS_PHOTOS_TAKEN: "progress_photos_taken",
  HEALTH_DATA_SYNCED: "health_data_synced",

  // Coach Interactions
  MESSAGE_SENT: "message_sent",
  MESSAGE_RECEIVED: "message_received",
  VIDEO_SHARED: "video_shared",
  FILE_DOWNLOADED: "file_downloaded",

  // Business Events
  GOAL_CHANGED: "goal_changed",
  PROTOCOL_UPDATED: "protocol_updated",
  SUBSCRIPTION_ACTION: "subscription_action",

  // Engagement
  BUTTON_CLICKED: "button_clicked",
  FORM_SUBMITTED: "form_submitted",
  SEARCH_PERFORMED: "search_performed",
  FILTER_APPLIED: "filter_applied",
  TAB_SWITCHED: "tab_switched",

  // Performance & Errors
  PAGE_LOAD_TIME: "page_load_time",
  API_REQUEST: "api_request",
  ERROR_OCCURRED: "error_occurred",
  CRASH_OCCURRED: "crash_occurred",
};

export const ANALYTICS_CONFIG = {
  MAX_EVENTS_PER_BATCH: 25,
  BATCH_TIMEOUT: 5000,
  MAX_RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000,
  MAX_QUEUE_SIZE: 1000,
  DEBUG_MODE: process.env.NODE_ENV === "development",
};
